import NotificationService from '../../services/NotificationService'
import ACTIONS from '../actionTypes/notification'

export const getNotificationList = (page = 1) => {
  return (dispatch) => {
    return NotificationService.getUserNotification(page, 50)
      .then(res => {
        if (res.data) {
          dispatch({ type: ACTIONS.GET_ALL_NOTIFCATION_SUCCESS, payload: res.data })
        }
      }).catch(() => { /* Fail Silently */ });
  }
}

export const receiveNotification = (notification) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.RECEIVE_NOTIFCATION, payload: notification });
  }
}

export const markAsRead = (ids) => {
  return (dispatch) => {
    return NotificationService.markAsRead(ids).then(res => {
      dispatch({ type: ACTIONS.MARK_ALL_AS_READ, payload: ids });
    });
  }
}

export const dismissPushNotification = (notification) => {
  return (dispatch) => {
    return dispatch({ type: ACTIONS.DISMISS_PUSH_NOTIFICATION, payload: notification });
  };
}